import { useModalStore } from '@/shared/lib/modalStore';
import type { ExchangeConfirmationArgs } from './types';
import { ExchangeConfirmationModal } from '../ui/ExchangeConfirmationModal';

const useExchangeConfirmationModal = () => {
  const { showDialogComponent } = useModalStore();

  const openExchangeConfirmationModal = (args: ExchangeConfirmationArgs) => {
    showDialogComponent({
      component: <ExchangeConfirmationModal {...args} />,
    });
  };

  return { openExchangeConfirmationModal };
};

export { useExchangeConfirmationModal };
